import Label from "@marginly/ui/components/label";
import React, { useEffect, useState } from "react";

import { ClockIcon } from "./clock-icon";
import { getTimeDifference } from "./get-time-difference";

const UPDATE_INTERVAL_MS = 1000;

interface Props {
  endTime: Date;
  textBefore?: string | React.ReactNode;
}

export function TimerLabel({ endTime, textBefore }: Props) {
  const [time, setTime] = useState("");

  useEffect(() => {
    const id = setInterval(() => {
      const { days, hours, minutes } = getTimeDifference({
        finishDate: endTime,
      });
      setTime(`${days}d ${hours}h ${minutes}m`);
    }, UPDATE_INTERVAL_MS);

    return () => {
      clearInterval(id);
    };
  }, [endTime]);

  return time ? (
    <Label icon lg>
      <ClockIcon />
      {textBefore}
      {time}
    </Label>
  ) : null;
}
